import {
  adcvdCert,
  bifacCert201,
  countries, declaration, entityRoleCode,
  feeCode,
  feeExemptionCode,
  irClassCode, issuerLocationTypeOption, laceyActDeclarationOption, lcpoType,
  otherIrClassCode,
  partyType, processingCodeOption, programCode, programCodeOption, secSpecialProgram, specialProgram,
  stsCert301, yesNoOption
} from "./options";

const items = [
  {
    name: 'esLine',
    label: 'ES Line',
    type: 'number',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'lineReference',
    label: 'Line Reference',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'tariff1',
    label: 'Tariffs',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  /*
  {
    name: 'tariff2',
    label: '2nd Tariff',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  */
  {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'countryOfOrigin',
    label: 'C/O',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'quantity',
    label: 'Qty',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'goodsValue',
    label: 'Value',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'dutyAmtSum',
    label: 'Duty',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'fda',
    label: 'FDA',
    type: 'boolean',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'epa',
    label: 'EPA',
    type: 'boolean',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'invoiceNo',
    label: 'Invoice #',
    type: 'text',
    maxLength: 17,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const header = [
  ...items,
  {
    name: 'chargesAmt',
    label: 'Charges Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'countryOfExport',
    label: 'Country of Export',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'dateOfExport',
    label: 'Date of Export',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'portOfLading',
    label: 'Port of Lading',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'grossWeightKgs',
    label: 'Gross Weight (KGS)',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'adCaseNonReimbursementStatement',
    label: 'AD Case Non-Reimbursment Statement',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'sanctionDisclaimIndicator',
    label: 'Sanction Disclaim Indicator',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'relatedPartyIndicator',
    label: 'Related Party Indicator',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'naftaNetCostIndicator',
    label: 'NAFTA Net Cost Indicator',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'irTaxClassCode',
    label: 'IR Class Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'irTaxAmount',
    label: 'IR Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'otherIrTaxClassCode',
    label: 'Other IR Class Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'otherIrTaxAmount',
    label: 'Other IR Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'feeExemptionCode',
    label: 'Fee Exemption Code',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'specialProgram',
    label: 'Special Program',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'secondarySpecialProgram',
    label: 'Secondary Special Program',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'lcpoType',
    label: 'LCPO Type',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'lcpoNumber',
    label: 'LCPO Number',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'manufacturerSupplier',
    label: 'Manufacturer / Supplier',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'deliveredTo',
    label: 'Delivered To',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'soldToId',
    label: 'Sold To ID',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'foreignExporter',
    label: 'Exporter',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const tariff = [
  {
    name: 'htsNumber',
    label: 'Tariff',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'qty1',
    label: 'Qty 1',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'uom1',
    label: 'UOM 1',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'qty2',
    label: 'Qty 2',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'uom2',
    label: 'UOM 2',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'qty3',
    label: 'Qty 3',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'uom3',
    label: 'UOM 3',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'goodsValue',
    label: 'Goods Value',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'tariffRate',
    label: 'Tariff Rate',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'dutyAmt',
    label: 'Duty Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'tariffDescription',
    label: 'Tariff Description',
    type: 'text',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const pga = [
  {
    name: 'agencyCode',
    label: 'Agency Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'programCode',
    label: 'Program Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'disclaimer',
    label: 'Disclaimer',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
];

const manifest = [
  {
    name: 'masterBill',
    label: 'Master Bill',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'houseBill',
    label: 'House Bill',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'quantity',
    label: 'Manifest Qty',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'units',
    label: 'Manifest UOM',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'containerNo',
    label: 'Container No.',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const party = [
  {
    name: 'partyCode',
    label: 'Party Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'identifier',
    label: 'Party Identifier Number',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'duns',
    label: 'DUNS',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'address1',
    label: 'Address 1',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'address2',
    label: 'Address 2',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    type: 'new',
    ignoreColumn: true
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'stateProvince',
    label: 'State / Province',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'country',
    label: 'Country',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
];

const userFee = [
  {
    name: 'feeCode',
    label: 'Line User Fee Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'fee',
    label: 'Line User Fee',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const additional = [
  {
    name: 'infoTypeCode',
    label: 'Addition Info Code',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'info',
    label: 'Addition Value',
    type: 'textarea',
    maxLength: 76,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const lineItem = [
  {
    name: 'esLine',
    label: 'Entry Line',
    type: 'number',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'description',
    label: 'Description',
    type: 'text',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'lineReference',
    label: 'Line Reference',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'invoiceNo',
    label: 'Invoice No.',
    type: 'text',
    maxLength: 17,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'countryOfOrigin',
    label: 'Country of Origin',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'goodsValue',
    label: 'Goods Value',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'dutyAmtSum',
    label: 'Duty',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'chargesAmt',
    label: 'Charges Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'countryOfExport',
    label: 'Country of Export',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'dateOfExport',
    label: 'Date of Export',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'portOfLading',
    label: 'Port of Lading',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'grossWeightKgs',
    label: 'Gross Weight (KGS)',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'manufacturerSupplier',
    label: 'Manufacturer / Supplier',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'foreignExporter',
    label: 'Exporter',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'deliveredTo',
    label: 'Delivered To',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
  {
    name: 'soldToId',
    label: 'Sold To ID',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'basic',
  },
]

const lineItemTariff = [
  {
    name: 'htsNumber',
    label: 'Tariff',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

const lineItemFee = [
  {
    name: 'feeExemptionCode',
    label: 'Fee Exemption Code',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fee',
  },
  {
    name: 'includeMPFFee',
    label: 'Include MPF fee',
    type: 'toggle',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fee',
  },
  {
    name: 'includeHMFFee',
    label: 'Include HMF Fee',
    type: 'toggle',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fee',
  },
]

const misc = [
  {
    name: 'adCaseNonReimbursementStatement',
    label: 'AD Case Non-Reimbursment Statement',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'sanctionDisclaimIndicator',
    label: 'Sanction Disclaim Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'relatedPartyIndicator',
    label: 'Related Party Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'naftaNetCostIndicator',
    label: 'NAFTA Net Cost Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'irTaxClassCode',
    label: 'IR Class Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'irTaxAmount',
    label: 'IR Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'otherIrTaxClassCode',
    label: 'Other IR Class Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'otherIrTaxAmount',
    label: 'Other IR Amount',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'specialProgram',
    label: 'Special Program',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'secondarySpecialProgram',
    label: 'Secondary Special Program',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'lcpoType',
    label: 'LCPO Type',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'lcpoNumber',
    label: 'LCPO Number',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'adcvdCert',
    label: 'ADCVD CERT',
    type: 'auto',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'bifacCert201',
    label: '201BIFAC CERT',
    type: 'auto',
    maxLength: 13,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
  {
    name: 'stsCert301',
    label: '301STS CERT',
    type: 'auto',
    maxLength: 11,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'misc',
  },
]

const softwood = [
  {
    name: 'softwoodDeclarationIndicator',
    label: 'Softwood Lumber Declaration Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'softwood',
  },
  {
    name: 'softwoodExportPrice',
    label: 'Softwood Lumber Export Price',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'softwood',
  },
  {
    name: 'softwoodExportCharges',
    label: 'Softwood Lumber Export Charges',
    type: 'number',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'softwood',
  },
]

const steel = [
  {
    name: 'steelExclusionIndicator',
    label: 'Product Exclusion Identifier – Steel Product',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'steel',
  },
  {
    name: 'krExportCert',
    label: 'South Korean (KR) Export Steel Certificate',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'steel',
  },
  {
    name: 'meltPourApplicable',
    label: 'Steel Melt and Pour Country Applicability',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'steel',
  },
  {
    name: 'meltPourCountry',
    label: 'Country of Steel Melt and Pour',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'steel',
  },
]

const aluminum = [
  {
    name: 'aluminumExclusionIndicator',
    label: 'Product Exclusion Identifier – Aluminum Product',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'aluminum',
  },
  {
    name: 'primaryCountrySmeltApplicable',
    label: 'Primary Country of Smelt Applicability ',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'aluminum',
  },
  {
    name: 'primaryCountrySmeltCode',
    label: 'Primary Country of Smelt Code',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'aluminum',
  },
  {
    name: 'secondaryCountrySmeltApplicable',
    label: 'Secondary Country of Smelt Applicability',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'aluminum',
  },
  {
    name: 'secondaryCountrySmeltCode',
    label: 'Secondary Country of Smelt Code',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'aluminum',
  },
  {
    name: 'castCountryCode',
    label: 'Country of Cast Code',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'aluminum',
  },
]

const alcohol = [
  {
    name: 'groupName',
    label: 'Controlled Group Name',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'alcohol',
  },
  {
    name: 'foreignProducerIndicator',
    label: 'Foreign Producer Identifier',
    type: 'text',
    maxLength: 18,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'alcohol',
  },
  {
    name: 'foreignProducerName',
    label: 'Foreign Producer Name',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'alcohol',
  },
  {
    name: 'flavorCreditIndicator',
    label: 'Flavor Content Credit Indicator',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'alcohol',
  },
  {
    name: 'cbmaRateCode',
    label: 'CBMA Rate Designation Code',
    type: 'text',
    maxLength: 6,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'alcohol',
  },
  {
    name: 'ttbTaxRateConfirm',
    label: 'TTB Tax Rate (Confirmation)',
    type: 'number',
    maxLength: 8,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'alcohol',
  },
]

const pgaTscaOdsHeader = [
  {
    name: 'tscaOdsProgramCode',
    label: 'Program Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'header',
  },
  {
    name: 'tscaOdsDisDocumentSubmitted',
    label: 'DIS Document Submitted',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'header',
  },
  {
    name: 'tscaOdsProductDescription',
    label: 'Product Description',
    type: 'textarea',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'header',
  },
  {
    name: 'tscaOdsDeclaration',
    label: 'TSCA/ODS Declaration',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'header',
    sizeProp: { xs: 12 }
  },
]

const pgaTscaOdsIndividual = [
  {
    name: 'tscaOdsName',
    label: 'Name',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'individual',
  },
  {
    name: 'tscaOdsPhone',
    label: 'Phone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'individual',
  },
  {
    name: 'tscaOdsEmail',
    label: 'Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'individual',
  },
]

const pgaContainer = [
  {
    name: 'containerNum',
    label: 'Container Number',
    type: 'text',
    maxLength: 30,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

const pgaLaceyActFields = [
  {
    name: "laceyActLineValue",
    label: "Line Value",
    type: "number",
    maxLength: 12,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyHeader"
  },
  {
    name: "laceyActProductDescription",
    label: "Product Description",
    type: "text",
    maxLength: 127,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyHeader",
    sizeProp: { xs: 12, sm: 12, lg: 9, xl: 9 }
  },
  {
    name: "laceyActDeclaration",
    label: "Lacey Act Declaration",
    type: "auto",
    maxLength: 1,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyHeader",
    sizeProp: { xs: 12, sm: 12, lg: 9, xl: 9 }
  },
  {
    name: "laceyActSignatureDate",
    label: "Date of Signature",
    type: "date",
    maxLength: 10,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyHeader"
  }
]

const pgaLaceyActPartyFields = [
  {
    name: "laceyActDeclarationParty",
    label: "Declaration Party",
    type: "auto",
    maxLength: 3,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty"
  },
  {
    type: 'new',
    section: "laceyParty"
  },
  {
    name: "laceyActEntityAddress1",
    label: "Entity Address 1",
    type: "text",
    maxLength: 23,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty",
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 }
  },
  {
    name: "laceyActEntityAddress2",
    label: "Entity Address 2",
    type: "text",
    maxLength: 32,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty",
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 }
  },
  {
    name: "laceyActCity",
    label: "City",
    type: "text",
    maxLength: 21,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty"
  },
  {
    name: "laceyActStateProvince",
    label: "State/Province",
    type: "text",
    maxLength: 3,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty"
  },
  {
    name: "laceyActPostalCode",
    label: "Postal Code",
    type: "text",
    maxLength: 9,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty"
  },
  {
    name: "laceyActCountry",
    label: "Country",
    type: "auto",
    maxLength: 2,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    section: "laceyParty"
  }
]

const pgaLaceyActPartyContactFields = [
  {
    name: "contactName",
    label: "Contact Name",
    type: "text",
    maxLength: 23,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "contactTelephone",
    label: "Contact Telephone",
    type: "text",
    maxLength: 15,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "contactEmail",
    label: "Contact Email",
    type: "text",
    maxLength: 35,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  }
]

const pgaLaceyActHarvestFields = [
  {
    name: "name",
    label: "Constituent Name",
    type: "text",
    maxLength: 51,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "quantity",
    label: "Constituent Quantity",
    type: "number",
    maxLength: 12,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "unit",
    label: "Constituent Unit",
    type: "text",
    maxLength: 5,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "percent",
    label: "Percent",
    type: "number",
    maxLength: 7,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "scientificGenusName",
    label: "Genus Name",
    type: "text",
    maxLength: 22,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "scientificSpeciesName",
    label: "Species Name",
    type: "text",
    maxLength: 22,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "unknownHarvestSource",
    label: "Unknown Harvest Source",
    type: "text",
    maxLength: 1,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: "harvestCountry",
    label: "Country of Harvest",
    type: "auto",
    maxLength: 2,
    placeholder: "",
    defaultValue: "",
    required: false,
    disabled: false,
    icon: undefined,
    multiple: true
  }
]

const optionsMap = {
  castCountryCode : countries,
  secondaryCountrySmeltCode : countries,
  primaryCountrySmeltCode : countries,
  meltPourCountry : countries,
  feeExemptionCode : feeExemptionCode,
  secondarySpecialProgram : secSpecialProgram,
  specialProgram : specialProgram,
  lcpoType : lcpoType,
  irTaxClassCode : irClassCode,
  otherIrTaxClassCode : otherIrClassCode,
  stsCert301 : stsCert301,
  bifacCert201 : bifacCert201,
  adcvdCert : adcvdCert,
  adCaseNonReimbursementStatement : yesNoOption,
  sanctionDisclaimIndicator : yesNoOption,
  relatedPartyIndicator : yesNoOption,
  naftaNetCostIndicator : yesNoOption,
  softwoodDeclarationIndicator : yesNoOption,
  primaryCountrySmeltApplicable : yesNoOption,
  secondaryCountrySmeltApplicable : yesNoOption,
  flavorCreditIndicator : yesNoOption,
}

const feeCodeOptionsMap = {
  feeCode : feeCode,
}

const partyTypeOptionsMap = {
  partyCode : partyType,
}

const pgaOptionMap = {
  tscaOdsProgramCode : programCode,
  tscaOdsDeclaration : declaration,
  laceyActCountry : countries,
  laceyActDeclaration : laceyActDeclarationOption,
  laceyActDeclarationParty : entityRoleCode,
  tscaOdsDisDocumentSubmitted : yesNoOption,
  programCode: programCodeOption,
  processingCode: processingCodeOption,
  issuerLocationType: issuerLocationTypeOption,
}

const harvestCountryOptionMap = {
  harvestCountry : countries
}

export {
  items,
  header,
  tariff,
  pga,
  manifest,
  party,
  userFee,
  additional,
  lineItem,
  lineItemTariff,
  lineItemFee,
  misc,
  softwood,
  steel,
  aluminum,
  alcohol,
  pgaTscaOdsHeader,
  pgaTscaOdsIndividual,
  pgaContainer,
  pgaLaceyActFields,
  pgaLaceyActPartyFields,
  pgaLaceyActPartyContactFields,
  pgaLaceyActHarvestFields,
  optionsMap,
  feeCodeOptionsMap,
  partyTypeOptionsMap,
  pgaOptionMap,
  harvestCountryOptionMap
};
